<template>
  <div
      v-if="show"
      class="slider-wrapper flex between align-center fullWidth"
  >
    <span v-if="label">{{ label }}</span>
    <div class="w-75">
      <FpSlider
        v-model="range"
        :min="min"
        :max="max"
        @input="change($event)"
      />
    </div>
  </div>
</template>
<script>
import FpSlider from "@/components/FpSlider";
export default {
  name: "FilterSlider",
  props: {
    show: {
      type: Boolean,
      default: false
    },
    modelValue: {
      default: null
    },
    label: {
      type: String,
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
    }
  },
  components: {
    FpSlider
  },
  data() {
    return {
      value: null
    }
  },
  watch:{
    modelValue(value){
      this.value = value;
    }
  },
  computed: {
    range: {
      get() {
        return this.value || [this.min, this.max];
      },
      set(value) {
        this.value = value;
        this.$emit("update:value", value);
      }
    }
  },
  methods: {
    change(value) {
      this.$emit("change", value);
    }
  },
  mounted() {
    if(this.modelValue){
      this.value = this.modelValue;
    }
  }
}
</script>
<style scoped>
.slider-wrapper {
  margin-bottom: 25px;
  padding-inline-end: 10px;
}
</style>